<script>
    export let tic;
</script>
<svg
                class={tic}
                width="24"
                height="24"
                viewBox="0 0 24 24"
                stroke-width="2"
                stroke="currentColor"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path stroke="none" d="M0 0h24v24H0z" />
                <circle cx="6" cy="18" r="2" />
                <circle cx="18" cy="6" r="2" />
                <line x1="7.5" y1="16.5" x2="16.5" y2="7.5" />
              </svg>